import React, { ChangeEvent, HTMLAttributes } from 'react';
import { VariantProps } from 'class-variance-authority';
import { textInputVariant } from './textInputVariant';
import cn from '@/utils/cn';

interface TextInputProps
  extends HTMLAttributes<HTMLInputElement>,
    VariantProps<typeof textInputVariant> {
  label?: string;
  labelClassName?: string;
  required?: boolean;
  value?: string;
  placeholder?: string;
  type?: string;
  errorMessage?: string;
  maxLength?: number;
  onTextChange: (e: ChangeEvent<HTMLInputElement>) => void;
  containerClassName?: string;
  onFocus?: () => void;
  disabled?: boolean;
}

const TextInput: React.FC<TextInputProps> = ({
  label,
  variant,
  className,
  value,
  onTextChange,
  placeholder,
  type,
  errorMessage,
  maxLength,
  containerClassName,
  onFocus,
  disabled,
  ...props
}) => {
  return (
    <div className={containerClassName}>
      {label ? (
        <label
          htmlFor={`text-input-${label.replaceAll(' ', '_')}`}
          className="block mb-2 text-sm font-medium text-gray-900">
          {label}
        </label>
      ) : null}

      <input
        type={type ?? 'text'}
        name={label ? `text-input-${label.replaceAll(' ', '_')}` : 'text-input'}
        className={cn(textInputVariant({ variant: errorMessage ? 'error' : variant, className }))}
        value={value ?? ''}
        onChange={onTextChange}
        placeholder={placeholder}
        disabled={disabled}
        {...props}
        autoComplete="off"
        onFocus={onFocus}
        maxLength={maxLength ?? 999}
      />
      {errorMessage ? <p className="mt-2 text-xs text-error-darkred">{errorMessage}</p> : null}
    </div>
  );
};

export default TextInput;
